import { CompanyConfig, TimeFormat } from '../interface';

// TODO: need update!!!
export const JiffyConfig: CompanyConfig = {
  id: '3257e6a2-87f1-46fe-b498-72d6b78b379b',
  lang: 'en',
  langs: ['en'],
  name: 'Jiffy',
  nameSecondary: 'Jiffy',
  currency: '£',
  officialName: 'Jiffy',
  email: 'support@jiffygrocery.co.uk',
  feedbackEmail: 'support@jiffygrocery.co.uk',
  phonePlaceholder: '+44',
  defaultPhoneCode: '+44',
  phoneNumber: '+44 00 0 000 0000',
  ageRestricted: 21,
  timeZone: 'Europe/London',
  minimalOrderFeeThreshold: 700,
  address:
    '25 Saint Bride Street, Farringdon Within, Blackfriars, City of London, London, England, GBR',
  canonical: 'https://jiffy.com',
  warehouse: {
    default: 'DSKEZ',
    minimalOrderFeeWarehouseCodes: [],
    location: {
      lat: 51.50012200837545,
      lng: -0.11430929889524322,
    },
  },
  map: {
    center: { lat: 51.50012200837545, lng: -0.11430929889524322 },
    zoom: 12,
  },
  paymentMethods: ['cash', 'gpay', 'applepay', 'visa', 'mc'],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    // whatsapp: 'https://wa.me/971501515042',
    // facebook: 'https://www.facebook.com/cheers.citydrinksuae/',
    // instagram: 'https://www.instagram.com/citydrinksuae/',
    // tiktok: 'https://www.tiktok.com/@citydrinksuae/',
    // youtube: 'https://www.youtube.com/channel/UCzwC746u4WxzAs0fPOMfSMA/',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      paymentAndDeliveryPolicy: {
        label: 'paymentAndDeliveryPolicy',
        link: '/legals#payment-and-delivery',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      salesAndReturnPolicy: {
        label: 'salesAndReturnPolicy',
        link: '/legals#sales-and-returns-policies-and-consumer',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
  },
  referral: {
    code: 'SWIFFTUCDAVIS',
    discount: '15%',
    minBasket: '15',
    downloadAppLink: 'https://click.jiffy.shop/PZKk/f11c621',
  },
  points: {
    value: '1=1c.',
    pointsPerUnit: 15,
    icon: 'coins',
  },
  appStoreUrl: {
    ios: '',
    android: '',
  },
  apis: {},
  countryCode: 'GB',
  license: {
    name: 'Cloud Retail LTD',
    numberPrinary: 'License Number',
  },
  defaultVolumeDisplay: '1x',
};
